var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "lang-btn", on: { click: _vm.openList } }, [
    _c("img", {
      attrs: {
        src: require(`@/assets/img/lang/${
          _vm.mapLang(_vm.$i18n.locale).img
        }.png`),
        alt: "",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }